import Footer from "./Footer"
import Navigation from "./Navigation"
import styled from "styled-components"

import Headshot from '../assets/Headshot.jpeg'
import QuoteForm from "./QuoteForm"
import { useNavigate } from "react-router-dom"

const Homepage = () =>{

    const navigate = useNavigate()
    
    return(
        <>
            <Navigation />
            <HomepageContainer>
                <IntroContainer>
                    <PhotoContainer>
                        <ProfilePhoto src={Headshot}/>
                    </PhotoContainer>
                    <IntroTextContainer>
                        <IntroGreeting>Hi, I'm Connor!</IntroGreeting>
                        <IntroText>I'm a software developer who designs and builds websites and applications for small businesses and individuals. 
                            I've helped several small businesses create or modernize existing websites, desktop and mobile applications.
                        </IntroText>
                        <br/>
                        <IntroText>Whether you need a new website for your portfolio, a mobile app for your business, or a desktop application to manage and maintain your 
                            schedule, I can help bring your ideas to life!                              
                        </IntroText>
                        <br />
                        <IntroText>
                            Submit the form below to request a quote!
                        </IntroText>

                    </IntroTextContainer>
                </IntroContainer>

                <PortfolioButtonContainer>
                    <PortfolioPageButton onClick={() => navigate('/portfoliopage')}>View My Portfolio</PortfolioPageButton>
                </PortfolioButtonContainer>
                
                
                
                <DemoContainer>

                </DemoContainer>
                <SubmissionFormContainer>
                    <QuoteForm />
                </SubmissionFormContainer>
            </ HomepageContainer>
            <Footer />
        </>
    )
}

const HomepageContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const IntroContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 48px;
    width: 100%;
    max-width: 900px;
    margin: 80px auto 0;
    padding: 0 24px;
    box-sizing: border-box;

    @media (max-width: 700px) {
        flex-direction: column;
        text-align: center;
        gap: 24px;
        margin-top: 48px;
    }
`

const PortfolioButtonContainer = styled.div`
    margin-top: 5%;
    text-align: center;
`

const PortfolioPageButton = styled.button`
    padding: 10px 20px;
    background-color: #2196F3;
    color: #E3F2FD;
    border: none;
    border-radius: 4px;
    font-family: inherit;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover{
        background-color: #1976D2;
    }

    @media (max-width: 700px) {
        padding: 8px 14px;
        font-size: 13px;
        white-space: nowrap;
    }
`


const PhotoContainer = styled.div`
    flex-shrink: 0;
`

const ProfilePhoto = styled.img`
    width: 180px;
    height: 180px;
    object-fit: cover;
    border-radius: 50%;
    border: 4px solid #2196F3;
    box-shadow: 0 12px 28px rgba(33, 150, 243, 0.25);
`

const IntroTextContainer = styled.div`
    color: #0D47A1;
`

const IntroGreeting = styled.h1`
    font-size: 32px;
    font-weight: 700;
    margin: 0 0 12px;
    letter-spacing: 0.2px;
`

const IntroText = styled.p`
    font-size: 18px;
    line-height: 1.6;
    color: #1B1B1B;
    margin: 0;
`

const DemoContainer = styled.div`
    width: 100%;
    height: 10%;
`

const SubmissionFormContainer = styled.div`
    width: 100%;
    margin-top: 5%;
    margin-bottom: 100px;
`


export default Homepage